import { LandingHorizontalBlock } from '../../../landingComponents/containers/common';
import Greeting from './greeting';
import YouWillGet from './youWillGet';
import PopularTests from './popularTests';
import ServiceInfo from './serviceInfo';
import WhyLametri from './whyLametri';
import Founders from './founders';
import Advice from './advice';
import styles from './home.module.scss';
import BreadcrumbSchema from 'src/components/breadcrumbs/schema';

const LandingHome = () => {
  return (
    <>
      <BreadcrumbSchema description="Система для автоматического анализа и расшифровки медицинских данных, в том числе биохимических тестов и жалоб по оцифрованным официальным медицинским документам" />
      <LandingHorizontalBlock className={styles.greeting}>
        <Greeting />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock>
        <YouWillGet />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock>
        <PopularTests />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock className={styles.serviceInfo}>
        <ServiceInfo />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock>
        <WhyLametri />
      </LandingHorizontalBlock>
      {/* <LandingHorizontalBlock>
        <video
          id="vid0"
          class="vid"
          src="https://unifyvsn.co.uk/wp-content/uploads/2022/02/HYPERVSN_SmartV_Wall.mp4"
          muted="muted"
          // preload="auto"
          width="100%"
          
          // height="650"
          // autoplay="autoplay"
        ></video>
      </LandingHorizontalBlock> */}
      <LandingHorizontalBlock className={styles.founders}>
        <Founders />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock className={styles.advice}>
        <Advice />
      </LandingHorizontalBlock>
    </>
  );
};

export default LandingHome;
